// Text helpers shared by public pages.
// Preserves author-cadastrado paragraph breaks in city/route descriptions and history.

/** Split a long text into paragraphs by blank lines, falling back to single-newline. */
export function splitParagraphs(text) {
  if (!text || typeof text !== "string") return [];
  const trimmed = text.trim();
  if (!trimmed) return [];
  const byBlank = trimmed.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  if (byBlank.length > 1) return byBlank;
  // fallback: single newlines still respected when only one paragraph was found
  return trimmed.split(/\n+/).map((p) => p.trim()).filter(Boolean);
}

/** Build a Google Maps search URL for a free-text query. */
export function mapsSearchUrl(query) {
  if (!query) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

/** Build a maps URL preferring coordinates over query. */
export function mapsLocationUrl({ lat, lng, query } = {}) {
  if (typeof lat === "number" && typeof lng === "number") {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  }
  return mapsSearchUrl(query);
}
